import*as e from"react";const t=e.createContext({lineDescription:"",lineUrl:{},refreshLine:()=>{}});export{t as LineDescriptionContext};
//# sourceMappingURL=line-description.js.map
